import { Link } from "react-router-dom";
import Logo from '../../../img/logo/logo_biotech.svg'

function Header() {
    return (
        <>
            <header className="App-header">
                <div className="mx-width">
                    <div>
                        <img src={Logo} alt="logo biotech service" className="logo"/>
                    </div>
                    <div>
                        <a href="#home">Home</a>
                        <a href="#about">Over ons</a>
                        <a href="#about">Hamilton</a>
                        <a href="#references">Referencies</a>
                        <a href="#contact">Contact</a>
                        <Link to="/english" onClick={() => {window.location.href="/english"}}>🇬🇧</Link>
                    </div>
                </div>
            </header>
        </>
    );
  }
  
  export default Header;
  